import axios from 'axios';
import { keycloak } from './keycloak';

const api = axios.create({
  baseURL: '/',
});

// Guard against rapid redirect loops: only allow one login redirect at a time.
// Both the request interceptor (token refresh failure) and response interceptor
// (401) use this so concurrent failing requests don't trigger multiple redirects.
let loginRedirectPending = false;

function redirectToLogin() {
  if (!loginRedirectPending) {
    loginRedirectPending = true;
    keycloak.login();
  }
}

api.interceptors.request.use(async (config) => {
  // Ensure token is fresh (refresh if expiring in <30s)
  if (keycloak.authenticated) {
    try {
      await keycloak.updateToken(30);
    } catch {
      redirectToLogin();
      return Promise.reject(new Error('Session expired'));
    }
    config.headers.Authorization = `Bearer ${keycloak.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  },
);

export default api;
